webpackJsonp([10579619878313],{

/***/ 1297:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Bounty;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _list = __webpack_require__(116);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _HeroSkinny = __webpack_require__(148);
	
	var _HeroSkinny2 = _interopRequireDefault(_HeroSkinny);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Bounty() {
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: _metadata2.default['bounty-policy'].title,
	      meta: [{
	        name: 'description',
	        content: _metadata2.default['bounty-policy'].description
	      }],
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: 'xl', position: 'bottom' },
	      _react2.default.createElement(
	        _pageWrap2.default,
	        { size: 's' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 'm', position: 'bottom' },
	          _react2.default.createElement(_HeroSkinny2.default, { tag: 'h1', title: 'Marvel Bug Bounty Program' }),
	          _react2.default.createElement(
	            _paragraph2.default,
	            { tag: 'span', size: 'l' },
	            'Keeping your marvellous prototypes and user information safe and secure is a top priority and a core value for us as a company. As such, We welcome the contribution of external security researchers and look forward to awarding them for their invaluable contribution to the security of all Marvel users. No technology is perfect, and Marvel believes that working with skilled security researchers across the globe is crucial in identifying weaknesses in any technology. If you believe you\'ve found a security issue in our product or service, we encourage you to notify us. We welcome working with you to resolve the issue promptly. Reported bugs will be assessed by our security team to determine if they qualify for a reward. Please report a potential security issue immediately. Marvel will consider the impact to the company and to our users and will calculate the reward accordingly. Bug submissions will be reviewed within 30 days. This page is intended for security researchers and professionals. For general information about security at Marvel, please see our main Website',
	            ' ',
	            _react2.default.createElement(
	              _link2.default,
	              { type: 'blue', url: '/security/' },
	              'https://marvelapp.com/security'
	            ),
	            '. If you\'re having issues related to your individual account, then please visit our Help Center (',
	            _react2.default.createElement(
	              _link2.default,
	              {
	                type: 'blue',
	                url: 'https://help.marvelapp.com/',
	                target: '_blank'
	              },
	              'https://help.marvelapp.com/'
	            ),
	            '). Love working on Marvel? Then why not work for Marvel , We\u2019re hiring!',
	            ' ',
	            _react2.default.createElement(
	              _link2.default,
	              {
	                type: 'blue',
	                url: 'https://marvel.workable.com/',
	                target: '_blank'
	              },
	              'https://marvel.workable.com/'
	            )
	          ),
	          _react2.default.createElement(_spacing2.default, { type: 'margin', size: 's', position: 'bottom' }),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 's', position: 'bottom' },
	            _react2.default.createElement(
	              _heading2.default,
	              { size: 'xxl', weight: 'semibold' },
	              'Scope'
	            )
	          ),
	          _react2.default.createElement(
	            _paragraph2.default,
	            { tag: 'span' },
	            'Our Bug Bounty program is limited to security vulnerabilities in Marvel mobile and web applications; do not attempt phishing attacks against our users in any circumstances. Out of concern for the availability of our services to all users, please do not attempt to carry out DoS attacks, spam people, or do other similarly questionable things. Vulnerability testing tools that automatically generate significant volumes of traffic are strictly prohibited. The following sites and applications are in scope for this program:',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _link2.default,
	              { type: 'blue', url: 'https://marvelapp.com/', target: '_blank' },
	              '* marvelapp.com (TLD Only)'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _link2.default,
	              {
	                type: 'blue',
	                url: 'https://itunes.apple.com/us/app/marvel-app/id765801658?mt=8',
	                target: '_blank'
	              },
	              '* Marvel iOS App',
	              ' '
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _link2.default,
	              {
	                type: 'blue',
	                url: 'https://play.google.com/store/apps/details?id=com.marvelapp',
	                target: '_blank'
	              },
	              '* Marvel Android App',
	              ' '
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Vulnerabilities reported on other Marvel properties or applications, such as blog.marvelapp.com are currently not eligible for monetary rewards'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 's', position: 'top' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 's', position: 'bottom' },
	            _react2.default.createElement(
	              _heading2.default,
	              { size: 'xxl', weight: 'semibold' },
	              'Non-qualifying vulnerabilities'
	            )
	          ),
	          _react2.default.createElement(
	            _paragraph2.default,
	            { tag: 'span', size: 's', color: 'slate' },
	            'The following bugs are unlikely to be eligible for a ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _list2.default,
	              { type: 'ordered' },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Issues found through automated testing'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Scanner output or scanner-generated reports'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'CVE Vulnerabilities released within the last 60 days'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Missing http security headers'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Logout and other instances of low-severity Cross-Site Request Forgery'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'SSL/TLS best practices'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Denial of Service attacks or Rate limiting issues'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Brute Force attacks'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Lack of Captcha'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Lack of Secure/HTTPOnly flags on non-sensitive Cookies'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Spam including:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'SPF and DKIM issues'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Content injection'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Hyperlink injection in emails'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Content Spoofing / text injection',
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Issues relating password and account recovery policies, such as reset link expiration or password complexity'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Full-Path Disclosure on any property'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Clickjacking/UI redressing with no practical security impact'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'CSRF-able actions that do not require authentication (or a session) to exploit'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Reports related to the following security-related headers:'
	                ),
	                _react2.default.createElement(
	                  _list2.default,
	                  { type: 'ordered' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '* Strict Transport Security (HSTS)'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '* XSS mitigation headers (X-Content-Type and X-XSS-Protection)'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '* X-Content-Type-Options'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '* Content Security Policy (CSP) settings (excluding nosniff in an exploitable scenario)'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                '* Bugs that do not represent any security risk'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                '* Security bugs related to third-party applications and services used by Marvel'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                '* Email signup and verification methods'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 's', position: 'top' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 's', position: 'bottom' },
	            _react2.default.createElement(
	              _heading2.default,
	              { size: 'xxl', weight: 'semibold' },
	              'Social Engineering'
	            )
	          ),
	          _react2.default.createElement(
	            _paragraph2.default,
	            { tag: 'span', size: 's', color: 'slate' },
	            'Social engineering attacks against our support and security team is strictly prohibited. This will most likely result in your account being closed and no bounty will be awarded.'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 's', position: 'top' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 's', position: 'bottom' },
	            _react2.default.createElement(
	              _heading2.default,
	              { size: 'xxl', weight: 'semibold' },
	              'Disclosure Policy'
	            )
	          ),
	          _react2.default.createElement(
	            _paragraph2.default,
	            { tag: 'span', size: 's', color: 'slate' },
	            _react2.default.createElement(
	              _list2.default,
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Let us know as soon as possible via',
	                ' ',
	                _react2.default.createElement(
	                  _link2.default,
	                  { target: 'mailto:security@marvelapp.com', type: 'blue' },
	                  'security@marvelapp.com'
	                ),
	                ' ',
	                'upon discovery of a potential security issue, and we\'ll make every effort to quickly resolve the issue.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Provide us a reasonable amount of time to resolve the issue before any disclosure to the public or a third-party.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Make a good faith effort to avoid privacy violations, destruction of data, and interruption or degradation of our service. Only interact with accounts you own or with explicit permission of the account holder.'
	              )
	            ),
	            'Thank you for helping keep Marvel and our users safe and secure!'
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-security-bountypolicy-js-9891dc302d08fc611253.js